export const filtroSesenta = () => { return arrayFechas(60) };
export const filtroUnMes = () => { return arrayFechas(31) };
export const filtroMedioMes = () => { return arrayFechas(14) };
export const filtroUnaSemana = () => { return arrayFechas(7) };
export const filtroUnDia = () => { return arrayFechas(1) };
export const filtroHoy = () => { return new Date().toISOString().slice(0,10) };


const arrayFechas = (lapsoDias) => {
  let fechaHoy = new Date();
  fechaHoy.setDate(fechaHoy.getDate() - lapsoDias);
  let fechaDesde = fechaHoy.toISOString().slice(0,10);
  return { desde: fechaDesde, hasta: filtroHoy() };
};

export const filtroHoySplitted = () => {
  let fechaHoy = filtroHoy();
  return {
    year: parseInt(fechaHoy.slice(0,4)),
    mes: parseInt(fechaHoy.slice(5,7)), 
    dia: parseInt(fechaHoy.slice(8,10))
  };
}